(() => {
  // The theme loads this asset only for the tiered Keto bundle.
  if (location.pathname.split('/').filter(Boolean).pop() !== 'byo-keto-bundle') return;

  function initializeEstimates(root) {
    if (root.dataset.rechargeEstimatesInitialized === 'true') return;
    root.dataset.rechargeEstimatesInitialized = 'true';
    const notes = new Map();
    let nextId = 0;

    function updateEstimates() {
      const priceButtons = new Set();
      root.querySelectorAll('.recharge-bundle-summary-sidebar button [aria-label], .recharge-bundle-summary-sticky-bar button [aria-label]').forEach(price => {
        const label = price.getAttribute('aria-label');
        if (!label.includes('Actual price') && !label.includes('Estimated total')) return;
        const button = price.closest('button');
        priceButtons.add(button);
        if (label.includes('Actual price')) price.setAttribute('aria-label', label.replace('Actual price', 'Estimated total'));

        let note = notes.get(button);
        if (!note) {
          note = document.createElement('p');
          note.id = `recharge-bundle-estimate-${++nextId}`;
          note.className = 'recharge-bundle-estimate';
          const title = document.createElement('span');
          title.className = 'recharge-bundle-estimate-label';
          title.textContent = 'Estimated total';
          note.append(title, document.createTextNode('Your final bundle discount and total appear in cart.'));
          notes.set(button, note);
        }
        if (button.previousElementSibling !== note) button.before(note);
        const descriptions = (button.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
        if (!descriptions.includes(note.id)) button.setAttribute('aria-describedby', [...descriptions, note.id].join(' '));
      });

      notes.forEach((note, button) => {
        if (priceButtons.has(button)) return;
        note.remove();
        const descriptions = (button.getAttribute('aria-describedby') || '').split(/\s+/).filter(id => id && id !== note.id);
        if (descriptions.length) button.setAttribute('aria-describedby', descriptions.join(' '));
        else button.removeAttribute('aria-describedby');
        notes.delete(button);
      });
    }

    updateEstimates();
    new MutationObserver(updateEstimates).observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-label', 'aria-describedby']
    });
  }

  function start() {
    const root = document.getElementById('bundling-app');
    if (root) initializeEstimates(root);
    new MutationObserver(() => {
      const currentRoot = document.getElementById('bundling-app');
      if (currentRoot) initializeEstimates(currentRoot);
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
